// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout___iDzX6{padding:var(--made-space-4-x) var(--made-space-10-x);display:flex;flex-direction:column;margin-bottom:25px}\n", "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.css"],"names":[],"mappings":"AAAA,gBACI,oDAAmC,CACnC,YAAS,CACT,qBAAgB,CAChB,kBACJ","sourcesContent":[".layout {\n    padding: var(--made-space-4-x) var(--made-space-10-x);\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": "layout___iDzX6"
};
export default ___CSS_LOADER_EXPORT___;
